import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Session';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Session extends RpcClass{

    /**
     *  @class Session
     *  @alias module:src/server/com/silkplm/rpc/Session.Session
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/sso/GoogleLoginResult.GoogleLoginResult>}
     */
     decodeAzureId(id) {
            return RpcClass.rpcCallFixed('/rpc/session/decode-azure-id', [id]);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/sso/GoogleLoginResult.GoogleLoginResult>}
     */
     decodeGoogleId(id) {
            return RpcClass.rpcCallFixed('/rpc/session/decode-google-id', [id]);
    }
    /** 
     * @async
     * @param compressionOn {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     enableCompression(compressionOn) {
            return RpcClass.rpcCall('/rpc/session/enable-compression', [compressionOn]);
    }
    /** 
     * @async
     * @param domainName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/OrganizationPublicInfo.OrganizationPublicInfo>}
     */
     extractOrganizationFromDomain(domainName) {
            return RpcClass.rpcCall('/rpc/session/extract-organization-from-domain', [domainName]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getBugzillaToken() {
            return RpcClass.rpcCall('/rpc/session/get-bugzilla-token', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getOrganizationNameByUserId() {
            return RpcClass.rpcCall('/rpc/session/get-organization-name-by-user-id', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getSlackLink() {
            return RpcClass.rpcCall('/rpc/session/get-slack-link', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getWindowUUID() {
            return RpcClass.rpcCallFixed('/rpc/session/get-window-u-u-i-d', []);
    }
    /** 
     * @async
     * @param tag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/OrganizationDeletedException.OrganizationDeletedException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     integrationSignIn(tag) {
            return RpcClass.rpcCallFixed('/rpc/session/integration-sign-in', [tag]);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param login {string} 
     * @param password {string} 
     * @param tag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/OrganizationDeletedException.OrganizationDeletedException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     integrationSignIn(organization, login, password, tag) {
            return RpcClass.rpcCallFixed('/rpc/session/integration-sign-in', [organization, login, password, tag]);
    }
    /** 
     * @async
     * @param token {string} 
     * @param tag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/OrganizationDeletedException.OrganizationDeletedException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     integrationSignInToken(token, tag) {
            return RpcClass.rpcCallFixed('/rpc/session/integration-sign-in-token', [token, tag]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     keepAlive() {
            return RpcClass.rpcCallFixed('/rpc/session/keep-alive', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserSettings.UserSettings>}
     */
     loadUserSettings() {
            return RpcClass.rpcCall('/rpc/session/load-user-settings', []);
    }
    /** 
     * @async
     * @param mail {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     orgsByEmail(mail) {
            return RpcClass.rpcCall('/rpc/session/orgs-by-email', [mail]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     paymentsEnabled() {
            return RpcClass.rpcCall('/rpc/session/payments-enabled', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     reportBrokenWebSocket() {
            return RpcClass.rpcCallFixed('/rpc/session/report-broken-web-socket', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     sendShutdownMessage() {
            return RpcClass.rpcCall('/rpc/session/send-shutdown-message', []);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param login {string} 
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/OrganizationDeletedException.OrganizationDeletedException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signIn(organization, login, password) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-in', [organization, login, password]);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param ssoData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signInWithSSO(organization, ssoData) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-in-with-s-s-o', [organization, ssoData]);
    }
    /** 
     * @async
     * @param ssoData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signInWithSSODetectOrg(ssoData) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-in-with-s-s-o-detect-org', [ssoData]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     signOut() {
            return RpcClass.rpcCallFixed('/rpc/session/sign-out', []);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param loginEmail {string} 
     * @param password {string} 
     * @param captchaToken {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signUp(organization, loginEmail, password, captchaToken) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-up', [organization, loginEmail, password, captchaToken]);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param loginEmail {string} 
     * @param password {string} 
     * @param captchaToken {string} 
     * @param autoconf {module:src/server/com/silkplm/rpc/dto/SignUpAutoconf.SignUpAutoconf} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signUpWithAutoconf(organization, loginEmail, password, captchaToken, autoconf) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-up-with-autoconf', [organization, loginEmail, password, captchaToken, autoconf]);
    }
    /** 
     * @async
     * @param ssoData {string} 
     * @param autoconf {module:src/server/com/silkplm/rpc/dto/SignUpAutoconf.SignUpAutoconf} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signUpWithAutoconfWithSSO(ssoData, autoconf) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-up-with-autoconf-with-s-s-o', [ssoData, autoconf]);
    }
    /** 
     * @async
     * @param ssoData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signUpWithSSO(ssoData) {
            return RpcClass.rpcCallFixed('/rpc/session/sign-up-with-s-s-o', [ssoData]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     silkEnv() {
            return RpcClass.rpcCall('/rpc/session/silk-env', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     userInfo() {
            return RpcClass.rpcCallFixed('/rpc/session/user-info', []);
    }
    /** 
     * @async
     * @param organization {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateOrganizationName(organization) {
            return RpcClass.rpcCall('/rpc/session/validate-organization-name', [organization]);
    }
    /** 
     * @async
     * @param organization {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateOrganizationNameForgotPassword(organization) {
            return RpcClass.rpcCall('/rpc/session/validate-organization-name-forgot-password', [organization]);
    }
    /** 
     * @async
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validatePassword(password) {
            return RpcClass.rpcCall('/rpc/session/validate-password', [password]);
    }
    /** 
     * @async
     * @param login {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateRegistrationEmail(login) {
            return RpcClass.rpcCall('/rpc/session/validate-registration-email', [login]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Session';
metadata.__type_short__ = 'Session';
Session.prototype.__metadata__ = metadata;

Session.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Session */
export default Session

export { Session }
